<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div class="">
      <b-card>
        <div slot="header" class="d-flex">
          <strong class="mdrive-header-text">Dealer Defined Fees</strong>
          <div class="ml-auto" v-if="activePartner">
            <button id="btnAddNewFee" class="btn btn-success" @click="showCreateModal()">
              <i class="fa fa-plus-square" title="Add a new fee"></i> <strong class="text-white">Add a new fee</strong>
            </button>
            <button id="btnSaveFees" class="btn btn-info" @click="saveCustomFees()">
              <i title="Add a new vehicle rule" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save Fees</strong>
            </button>
          </div>
        </div>

        <div>
          <b-card no-body>
            <b-tabs pills card v-model="tabIndex">
              <b-tab title="Lease New" :title-link-class="linkClass(0)">

                <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm m-0">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="1">Description</th>
                      <th aria-colindex="2">Included In</th>
                      <th class="text-center" aria-colindex="3">Tax</th>
                      <th class="text-center" aria-colindex="4">Tax in Cap</th>
                      <th aria-colindex="6">Fee Cost</th>
                      <th aria-colindex="7">Fee Charge</th>
                      <th aria-colindex="8"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!activePartner.lease.new.length" class="b-table-empty-row">
                      <td colspan="9"><div role="alert" aria-live="polite"><div class="text-center my-2">No fees defined yet.</div></div></td>
                    </tr>
                    <tr v-for="p in activePartner.lease.new" v-bind:key="p.rownum">
                      <td>
                        <b-form-input id="inplnDescription" :ref="'lnDesc'+p.rownum" type="text" v-model="p.description"
                                      @blur="checkForFeeName('lnDesc'+p.rownum, p, gLeaseNew)"></b-form-input>
                      </td>
                      <td>
                        <b-form-group style="padding-bottom:0px">
                          <b-form-radio-group v-model="p.incap" :options="options"></b-form-radio-group>
                        </b-form-group>
                      </td>
                      <td class="text-center"><b-form-checkbox class="mx-0 my-2" :id="'chklntaxable'+p.rownum" v-model="p.taxable"></b-form-checkbox></td>
                      <td class="text-center"><b-form-checkbox class="mx-0 my-2" :id="'chklntaxincap'+p.rownum" v-model="p.taxincap"></b-form-checkbox></td>
                      <td><b-form-input id="inplnCost" type="number" v-model.number="p.cost" @blur="sameFeeAlertForCost(p, gLeaseNew)"></b-form-input></td>
                      <td><b-form-input id="inplnAmount" type="number" v-model.number="p.value" @blur="sameFeeAlertForValue(p, gLeaseNew)"></b-form-input></td>
                      <td width="100px">
                        <button id="btnlnDelete" class="btn btn-danger text-white" @click="deleteFee(p, gLeaseNew)">
                          <i class="fa fa-trash-o fa-lg" title="Delete"></i>
                        </button>
                        <button id="btnlnCopy" class="btn btn-info text-white" @click="copyToNew(p)">
                          <i class="fa fa-copy fa-lg" title="Copy"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </b-tab>
              <b-tab title="Lease Used" :title-link-class="linkClass(1)">
                <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm m-0">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="1">Description</th>
                      <th aria-colindex="2">Included In</th>
                      <th class="text-center" aria-colindex="3">Tax</th>
                      <th class="text-center" aria-colindex="4">Tax in Cap</th>
                      <th aria-colindex="6">Fee Cost</th>
                      <th aria-colindex="7">Fee Charge</th>
                      <th aria-colindex="8"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!activePartner.lease.used.length" class="b-table-empty-row">
                      <td colspan="9"><div role="alert" aria-live="polite"><div class="text-center my-2">No fees defined yet.</div></div></td>
                    </tr>
                    <tr v-for="p in activePartner.lease.used" v-bind:key="p.rownum">
                      <td><b-form-input id="inpluDescription" :ref="'luDesc'+p.rownum" type="text" v-model="p.description" v-on:change="checkForFeeName('luDesc'+p.rownum, p, gLeaseUsed)"></b-form-input></td>
                      <td>
                        <b-form-group>
                          <b-form-radio-group v-model="p.incap" :options="options"></b-form-radio-group>
                        </b-form-group>
                      </td>
                      <td class="text-center"><b-form-checkbox class="mx-0 my-2" :id="'chklutaxable'+p.rownum" v-model="p.taxable"></b-form-checkbox></td>
                      <td class="text-center"><b-form-checkbox class="mx-0 my-2" :id="'chklutaxincap'+p.rownum" v-model="p.taxincap"></b-form-checkbox></td>
                      <td><b-form-input id="inpluCost" type="number" v-model.number="p.cost" @blur="sameFeeAlertForCost(p, gLeaseUsed)"></b-form-input></td>
                      <td><b-form-input id="inpluAmount" type="number" v-model.number="p.value" @blur="sameFeeAlertForValue(p, gLeaseUsed)"></b-form-input></td>
                      <td width="100px">
                        <button id="btnluDelete" class="btn btn-danger text-white" @click="deleteFee(p, gLeaseUsed)">
                          <i class="fa fa-trash-o fa-lg" title="Delete"></i>
                        </button>
                        <button id="btnluCopy" class="btn btn-info text-white" @click="copyToNew(p)">
                          <i class="fa fa-copy fa-lg" title="Copy"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </b-tab>
              <b-tab title="Retail New" :title-link-class="linkClass(2)">
                <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm m-0">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="1">Description</th>
                      <th class="text-center" aria-colindex="3">Tax</th>
                      <th aria-colindex="6">Fee Cost</th>
                      <th aria-colindex="7">Fee Charge</th>
                      <th aria-colindex="8"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!activePartner.retail.new.length" class="b-table-empty-row">
                      <td colspan="9"><div role="alert" aria-live="polite"><div class="text-center my-2">No fees defined yet.</div></div></td>
                    </tr>
                    <tr v-for="p in activePartner.retail.new" v-bind:key="p.rownum">
                      <td><b-form-input id="inprnDescription" :ref="'rnDesc'+p.rownum" type="text" v-model="p.description" v-on:change="checkForFeeName('rnDesc'+p.rownum, p, gRetailNew)"></b-form-input></td>
                      <td class="text-center"><b-form-checkbox class="mx-0 my-2" :id="'chkrntaxable'+p.rownum" v-model="p.taxable"></b-form-checkbox></td>
                      <td><b-form-input id="inprnCost" type="number" v-model.number="p.cost" @blur="sameFeeAlertForCost(p, gRetailNew)"></b-form-input></td>
                      <td><b-form-input id="inprnAmount" type="number" v-model.number="p.value" @blur="sameFeeAlertForValue(p, gRetailNew)"></b-form-input></td>
                      <td width="100px">
                        <button id="btnrnDelete" class="btn btn-danger text-white" @click="deleteFee(p, gRetailNew)">
                          <i class="fa fa-trash-o fa-lg" title="Delete"></i>
                        </button>
                        <button id="btnrnCopy" class="btn btn-info text-white" @click="copyToNew(p)">
                          <i class="fa fa-copy fa-lg" title="Copy"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-tab>

              <b-tab title="Retail Used" :title-link-class="linkClass(3)">
                <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm m-0">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="1">Description</th>
                      <th class="text-center" aria-colindex="3">Tax</th>
                      <th aria-colindex="6">Fee Cost</th>
                      <th aria-colindex="7">Fee Charge</th>
                      <th aria-colindex="8"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!activePartner.retail.used.length" class="b-table-empty-row">
                      <td colspan="9"><div role="alert" aria-live="polite"><div class="text-center my-2">No fees defined yet.</div></div></td>
                    </tr>
                    <tr v-for="p in activePartner.retail.used" v-bind:key="p.rownum">
                      <td><b-form-input id="inpruDescription" :ref="'ruDesc'+p.rownum" type="text" v-model="p.description" v-on:change="checkForFeeName('ruDesc'+p.rownum, p, gRetailUsed)"></b-form-input></td>

                      <td class="text-center"><b-form-checkbox class="mx-0 my-2" :id="'chkrutaxable'+p.rownum" v-model="p.taxable"></b-form-checkbox></td>
                      <td><b-form-input id="inpruCost" type="number" v-model.number="p.cost" @blur="sameFeeAlertForCost(p, gRetailUsed)"></b-form-input></td>
                      <td><b-form-input id="inpruAmount" type="number" v-model.number="p.value" @blur="sameFeeAlertForValue(p, gRetailUsed)"></b-form-input></td>
                      <td width="100px">
                        <button id="btnruDelete" class="btn btn-danger text-white" @click="deleteFee(p, gRetailUsed)">
                          <i class="fa fa-trash-o fa-lg" title="Delete"></i>
                        </button>
                        <button id="btnruCopy" class="btn btn-info text-white" @click="copyToNew(p)">
                          <i class="fa fa-copy fa-lg" title="Copy"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>

      </b-card>
    </div>

    <b-modal ref="createModal" hide-footer size="xl" title="Add a New Fee">

      <table id="tableModal" aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
        <thead class="thead-light">
          <tr>
            <th aria-colindex="1">Lease / Retail</th>
            <th aria-colindex="1">New / Used</th>
            <th aria-colindex="1">Description</th>
            <th aria-colindex="2">Included In</th>
            <th aria-colindex="3" class="text-center">Tax</th>
            <th aria-colindex="4" class="text-center">Tax in Cap</th>
            <th aria-colindex="5">Fee Cost</th>
            <th aria-colindex="6">Fee Charge</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b-form-select id="finTypeDropdModal" :options="['Lease','Retail','Both']" v-model="copyCustomFee.financeType"></b-form-select></td>
            <td><b-form-select id="newUsedDropdModal" :options="['New','Used','Both']" v-model="copyCustomFee.newused"></b-form-select></td>
            <td><b-form-input id="inpDescripModal" type="text" v-model="copyCustomFee.description"></b-form-input></td>
            <td>

              <b-form-group>
                <b-form-radio-group v-model="copyCustomFee.incap" :options="options" v-if="copyCustomFee.financeType !== 'Retail'"></b-form-radio-group>
              </b-form-group>
            </td>
            <td class="text-center"><b-form-checkbox id="chkTaxableModal" class="mx-0" v-model="copyCustomFee.taxable"></b-form-checkbox></td>
            <td class="text-center"><b-form-checkbox id="chkTaxInCapModal" class="mx-0" v-model="copyCustomFee.taxincap" v-if="copyCustomFee.financeType !== 'Retail'"></b-form-checkbox></td>
            <td><b-form-input type="number" id="inpCostModal" v-model.number="copyCustomFee.cost"></b-form-input></td>
            <td><b-form-input type="number" id="inpAmountModal" v-model.number="copyCustomFee.value"></b-form-input></td>
          </tr>
        </tbody>
      </table>
      <div class="float-right">
        <b-btn id="btnCancelModal" class="mt-3" variant="danger" @click="cancelCreateModal">Cancel</b-btn>
        <b-btn id="btnAddModal" class="mt-3 " variant="success" @click="createCustomFee"><i class="fa fa-plus-square mr-2" title="Add fee"></i>Add</b-btn>
      </div>
    </b-modal>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import loading from 'vue-full-loading'
import { confirm } from 'devextreme/ui/dialog'

export default {
  components: {
    loading
  },
  created () {
    axios.get('/api/customfee/loaddata')
      .then(response => {
        this.boolLoading = false
        // console.log(JSON.stringify(response.data))
        this.activePartner = response.data.data
        this.activePartner.name = 'All Partner Fee'
      })
      .catch(error => {
        if (error.response.status === 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      activePartner: { lease: { new: [], used: [] }, retail: { new: [], used: [] } },
      copyPartner: { partnerId: 0, name: null },
      copyCustomFee: { financeType: 'Lease', newused: 'New', description: '', incap: false, taxable: false, taxincap: false, value: null },
      blankCustomFee: { financeType: 'Lease', newused: 'New', description: '', incap: false, taxable: false, taxincap: false, value: null },
      partners: [],
      listCustomFees: [],
      options: [
        { text: 'In Cap', value: true },
        { text: 'Fees', value: false }
      ],
      tabIndex: 0,
      lastEdit: '',
      gLeaseNew: 'Lease New',
      gRetailNew: 'Retail New',
      gLeaseUsed: 'Lease Used',
      gRetailUsed: 'Retail Used'
    }
  },
  methods: {
    showCreateModal () {
      this.$refs.createModal.show()
    },
    copyToNew (customFee) {
      this.copyCustomFee = JSON.parse(JSON.stringify(customFee))
      this.copyCustomFee.parentId = null
      this.$refs.createModal.show()
    },
    createCustomFee () {
      var self = this

      var cfee = JSON.parse(JSON.stringify(self.copyCustomFee))
      this.showDismissibleAlert = false
      var invalid = false

      function validate (listFees, cFee) {
        var invalid = false
        var p = listFees.filter(f => { return f.description.trim() === cFee.description.trim() })
        if (p.length > 0) { invalid = true }
        return invalid
      }

      function addItem (listFees, cFee) {
        var cfcount = listFees.length
        cfcount++
        var copyfee = JSON.parse(JSON.stringify(cFee))
        copyfee.rownum = cfcount
        listFees.push(copyfee)
      }

      let addLeaseNew = false
      let addLeaseUsed = false
      let addRetailNew = false
      let addRetailUsed = false

      if (cfee.financeType === 'Both') {
        if (cfee.newused === 'Both') {
          addLeaseNew = true
          addLeaseUsed = true
          addRetailNew = true
          addRetailUsed = true
        } else if (cfee.newused === 'New') {
          addLeaseNew = true
          addRetailNew = true
        } else if (cfee.newused === 'Used') {
          addLeaseUsed = true
          addRetailUsed = true
        }
      } else if (cfee.financeType === 'Lease') {
        if (cfee.newused === 'Both') {
          addLeaseNew = true
          addLeaseUsed = true
        } else if (cfee.newused === 'New') {
          addLeaseNew = true
        } else if (cfee.newused === 'Used') {
          addLeaseUsed = true
        }
      } else if (cfee.financeType === 'Retail') {
        if (cfee.newused === 'Both') {
          addRetailNew = true
          addRetailUsed = true
        } else if (cfee.newused === 'New') {
          addRetailNew = true
        } else if (cfee.newused === 'Used') {
          addRetailUsed = true
        }
      }

      let z = 0
      let tabname = ''
      duplicateDescription: {
        while (z === 0) {
          z = 1
          if (addLeaseNew) {
            invalid = validate(self.activePartner.lease.new, cfee)
            if (invalid) {
              tabname = self.gLeaseNew
              break duplicateDescription
            }
          }

          if (addLeaseUsed) {
            invalid = validate(self.activePartner.lease.used, cfee)
            if (invalid) {
              tabname = self.gLeaseUsed
              break duplicateDescription
            }
          }

          if (addRetailNew) {
            invalid = validate(self.activePartner.retail.new, cfee)
            if (invalid) {
              tabname = self.gRetailNew
              break duplicateDescription
            }
          }

          if (addRetailUsed) {
            invalid = validate(self.activePartner.retail.used, cfee)
            if (invalid) {
              tabname = self.gRetailUsed
              break duplicateDescription
            }
          }

          if (addLeaseNew) {
            addItem(self.activePartner.lease.new, cfee)
            self.tabIndex = 0
          }
          if (addLeaseUsed) {
            addItem(self.activePartner.lease.used, cfee)
            self.tabIndex = 1
          }
          if (addRetailNew) {
            addItem(self.activePartner.retail.new, cfee)
            self.tabIndex = 2
          }
          if (addRetailUsed) {
            addItem(self.activePartner.retail.used, cfee)
            self.tabIndex = 3
          }
        }
      }

      if (invalid) {
        self.errMsg = 'There is already a duplicate fee with the same description as ' + cfee.description + ' in ' + tabname
        self.showDismissibleAlert = true
        self.$refs.createModal.hide()
        return
      }

      self.copyCustomFee = JSON.parse(JSON.stringify(self.blankCustomFee))
      this.$refs.createModal.hide()
    },
    emitter (cfee, source, arg) {

    },
    checkForFeeName (event, item, grid) {
      var self = this
      self.showDismissibleAlert = false
      let duplicate = false

      if (grid === self.gLeaseNew && self.activePartner.lease.new.filter(f => { return f.description.trim() === item.description.trim() && f.rownum !== item.rownum }).length > 0) {
        duplicate = true
      }
      if (grid === self.gLeaseUsed && self.activePartner.lease.used.filter(f => { return f.description.trim() === item.description.trim() && f.rownum !== item.rownum }).length > 0) {
        duplicate = true
      }
      if (grid === self.gRetailNew && self.activePartner.retail.new.filter(f => { return f.description.trim() === item.description.trim() && f.rownum !== item.rownum }).length > 0) {
        duplicate = true
      }
      if (grid === self.gRetailUsed && self.activePartner.retail.used.filter(f => { return f.description.trim() === item.description.trim() && f.rownum !== item.rownum }).length > 0) {
        duplicate = true
      }

      if (duplicate) {
        self.errMsg = 'There is already a duplicate fee with the same description as ' + item.description + ' in ' + grid
        self.showDismissibleAlert = true

        self.$refs[event][0].focus()
      }
    },
    sameFeeAlertForCost (item, grid) {
      var self = this

      if (item.ignoreAlert === true) {
        return
      }

      self.showDismissibleAlert = false

      let tabnames = []

      if (grid !== self.gLeaseNew && self.activePartner.lease.new.filter(f => {
        return f.description.trim() === item.description.trim() && f.cost !== item.cost
      }).length > 0) {
        tabnames.push(self.gLeaseNew)
      }
      if (grid !== self.gLeaseUsed && self.activePartner.lease.used.filter(f => {
        return f.description.trim() === item.description.trim() && f.cost !== item.cost
      }).length > 0) {
        tabnames.push(self.gLeaseUsed)
      }
      if (grid !== self.gRetailNew && self.activePartner.retail.new.filter(f => {
        return f.description.trim() === item.description.trim() && f.cost !== item.cost
      }).length > 0) {
        tabnames.push(self.gRetailNew)
      }
      if (grid !== self.gRetailUsed && self.activePartner.retail.used.filter(f => {
        return f.description.trim() === item.description.trim() && f.cost !== item.cost
      }).length > 0) {
        tabnames.push(self.gRetailUsed)
      }

      if (tabnames.length > 0) {
        let result = confirm('Do you also want to change fee(s) with the same description as ' + item.description + ' in ' + tabnames.toString() + '?', 'Warning')
        result.then((dialogResult) => {
          if (dialogResult) {
            tabnames.forEach(g => {
              var list = null
              if (g === self.gLeaseNew) { list = self.activePartner.lease.new }
              if (g === self.gLeaseUsed) { list = self.activePartner.lease.used }
              if (g === self.gRetailNew) { list = self.activePartner.retail.new }
              if (g === self.gRetailUsed) { list = self.activePartner.retail.used }

              var found1 = list.filter(f => { return f.description === item.description })[0]
              var x1 = list.indexOf(found1)
              var editOtherTabFee = JSON.parse(JSON.stringify(found1))
              editOtherTabFee.cost = item.cost
              Vue.delete(list, x1)
              list.push(editOtherTabFee)
            })
          } else {
            item.ignoreAlert = true
            let word = tabnames.length === 1 ? 'is a fee' : 'are fees'
            self.errMsg = 'There ' + word + ' with the same description as ' + item.description + ' in ' + tabnames.toString() + ' with different fee cost'
            self.showDismissibleAlert = true
            self.dismissibleType = 'warning'
          }
        })
      }
    },
    sameFeeAlertForValue (item, grid) {
      var self = this

      if (item.ignoreAlert === true) {
        return
      }

      self.showDismissibleAlert = false

      let tabnames = []

      if (grid !== self.gLeaseNew && self.activePartner.lease.new.filter(f => {
        return f.description.trim() === item.description.trim() && f.value !== item.value
      }).length > 0) {
        tabnames.push(self.gLeaseNew)
      }
      if (grid !== self.gLeaseUsed && self.activePartner.lease.used.filter(f => {
        return f.description.trim() === item.description.trim() && f.value !== item.value
      }).length > 0) {
        tabnames.push(self.gLeaseUsed)
      }
      if (grid !== self.gRetailNew && self.activePartner.retail.new.filter(f => {
        return f.description.trim() === item.description.trim() && f.value !== item.value
      }).length > 0) {
        tabnames.push(self.gRetailNew)
      }
      if (grid !== self.gRetailUsed && self.activePartner.retail.used.filter(f => {
        return f.description.trim() === item.description.trim() && f.value !== item.value
      }).length > 0) {
        tabnames.push(self.gRetailUsed)
      }

      if (tabnames.length > 0) {
        let result = confirm('Do you also want to change fee(s) with the same description as ' + item.description + ' in ' + tabnames.toString() + '?', 'Warning')
        result.then((dialogResult) => {
          if (dialogResult) {
            tabnames.forEach(g => {
              var list = null
              if (g === self.gLeaseNew) { list = self.activePartner.lease.new }
              if (g === self.gLeaseUsed) { list = self.activePartner.lease.used }
              if (g === self.gRetailNew) { list = self.activePartner.retail.new }
              if (g === self.gRetailUsed) { list = self.activePartner.retail.used }

              var found1 = list.filter(f => { return f.description === item.description })[0]
              var x1 = list.indexOf(found1)
              var editOtherTabFee = JSON.parse(JSON.stringify(found1))

              editOtherTabFee.value = item.value
              Vue.delete(list, x1)
              list.push(editOtherTabFee)
            })
          } else {
            item.ignoreAlert = true
            let word = tabnames.length === 1 ? 'is a fee' : 'are fees'
            self.errMsg = 'There ' + word + ' with the same description as ' + item.description + ' in ' + tabnames.toString() + ' with different fee charge'
            self.showDismissibleAlert = true
            self.dismissibleType = 'warning'
          }
        })
      }
    },
    deleteFee (item, grid) {
      var self = this
      function delItem (grid, list, item) {
        let tabnames = []

        if (grid !== self.gLeaseNew && self.activePartner.lease.new.filter(f => { return f.description.trim() === item.description.trim() }).length > 0) {
          tabnames.push(self.gLeaseNew)
        }
        if (grid !== self.gLeaseUsed && self.activePartner.lease.used.filter(f => { return f.description.trim() === item.description.trim() }).length > 0) {
          tabnames.push(self.gLeaseUsed)
        }
        if (grid !== self.gRetailNew && self.activePartner.retail.new.filter(f => { return f.description.trim() === item.description.trim() }).length > 0) {
          tabnames.push(self.gRetailNew)
        }
        if (grid !== self.gRetailUsed && self.activePartner.retail.used.filter(f => { return f.description.trim() === item.description.trim() }).length > 0) {
          tabnames.push(self.gRetailUsed)
        }

        if (tabnames.length > 0) {
          let result = confirm('Do you want to delete fees with the same description as ' + item.description + ' in ' + tabnames.toString() + '?', 'Warning')
          result.then((dialogResult) => {
            if (dialogResult) {
              tabnames.forEach(g => {
                var grid1 = null
                if (g === self.gLeaseNew) { grid1 = self.activePartner.lease.new }
                if (g === self.gLeaseUsed) { grid1 = self.activePartner.lease.used }
                if (g === self.gRetailNew) { grid1 = self.activePartner.retail.new }
                if (g === self.gRetailUsed) { grid1 = self.activePartner.retail.used }

                var found1 = grid1.filter(f => { return f.description === item.description })[0]
                var x1 = grid1.indexOf(found1)
                Vue.delete(grid1, x1)
              })
            } else {
              let word = tabnames.length === 1 ? 'is a fee' : 'are fees'
              self.errMsg = 'There ' + word + ' with the same description as ' + item.description + ' in ' + tabnames.toString()
              self.showDismissibleAlert = true
            }
          })
        }

        var found = list.filter(f => { return f.rownum === item.rownum })[0]
        var x = list.indexOf(found)
        Vue.delete(list, x)
      }

      if (grid === self.gLeaseNew) { delItem(grid, self.activePartner.lease.new, item) }
      if (grid === self.gLeaseUsed) { delItem(grid, self.activePartner.lease.used, item) }
      if (grid === self.gRetailNew) { delItem(grid, self.activePartner.retail.new, item) }
      if (grid === self.gRetailUsed) { delItem(grid, self.activePartner.retail.used, item) }
    },
    cancelCreateModal () {
      this.copyCustomFee = JSON.parse(JSON.stringify(this.blankCustomFee))
      this.$refs.createModal.hide()
    },
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    saveCustomFees () {
      this.boolLoading = true
      var obj = { data: { partnerId: 0, lease: { new: [], used: [] }, retail: { new: [], used: [] } } }
      obj.data.lease.new = this.activePartner.lease.new
      obj.data.lease.used = this.activePartner.lease.used
      obj.data.retail.new = this.activePartner.retail.new
      obj.data.retail.used = this.activePartner.retail.used

        if (obj.data.lease.new && obj.data.lease.new.length > 0) {
          obj.data.lease.new.forEach(x => {
            if (!x.value) {
              x.value = 0
            }
          })
        }

        if (obj.data.lease.used && obj.data.lease.used.length > 0) {
          obj.data.lease.used.forEach(x => {
            if (!x.value) {
              x.value = 0
            }
          })
        }

        if (obj.data.retail.new && obj.data.retail.new.length > 0) {
          obj.data.retail.new.forEach(x => {
            if (!x.value) {
              x.value = 0
            }

            if (!x.cost) {
              x.cost = 0
            }
          })
        }

        if (obj.data.retail.used && obj.data.retail.used.length > 0) {
          obj.data.retail.used.forEach(x => {
            if (!x.value) {
              x.value = 0
            }

            if (!x.cost) {
              x.cost = 0
            }
          })
        }

        axios.post('/api/customfee/save', obj)
          .then(response => {
            this.errMsg = 'Dealer Defined Fees Saved'
            this.dismissibleType = 'success'
            this.showDismissibleAlert = true
            this.boolLoading = false
            if (obj.data.lease.new.length > 0 || obj.data.lease.used.length > 0 || obj.data.retail.new.length > 0 || obj.data.lease.retail.length > 0) {
              this.$emit('clicked', 'true')
            }
          })
          .catch(error => {
            if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

          console.log(error)
          this.boolLoading = false
          this.errMsg = 'There was an error saving data : ' + error
          this.showDismissibleAlert = true

          if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
        })
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>
<style scoped>
  .modal-lg {
    max-width: 70vw;
  }

  .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* Card Header */

  .card-header {
    padding: 1.25rem calc(1.25rem + 15px);
  }

  .mdrive-header-text {
    line-height: 35px;
  }

  #btnAddNewFee,
  #btnSaveFees {
    /* border-radius: .25rem; */
    margin-top: 0;
  }

  #btnSaveFees {
    margin-left: 10px;
  }

  #btnDelete,
  #btnCopy {
    /* border-radius: .25rem; */
  }

  @media (max-width: 768px) {
    .card-header > .d-flex {
      display: initial !important;
    }

    .mdrive-header-text {
      line-height: 35px;
      margin-bottom: 10px !important;
      width: 100%;
      position: relative;
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/DealerDefinedFees.vue